import { styled } from 'styled-components';

export const Archived = styled.p`
  display: inline-block;
  font-size: var(--font-baseline);
  margin-left: var(--spacing-small);
`;
